import { render, staticRenderFns } from "./VLOCRResult.vue?vue&type=template&id=73bfb0bc&scoped=true"
import script from "./VLOCRResult.vue?vue&type=script&lang=js"
export * from "./VLOCRResult.vue?vue&type=script&lang=js"
import style0 from "./VLOCRResult.vue?vue&type=style&index=0&id=73bfb0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bfb0bc",
  null
  
)

export default component.exports